import { render, staticRenderFns } from "./SafeLogList.vue?vue&type=template&id=cfe32080&scoped=true"
import script from "./SafeLogList.vue?vue&type=script&lang=js"
export * from "./SafeLogList.vue?vue&type=script&lang=js"
import style0 from "./SafeLogList.vue?vue&type=style&index=0&id=cfe32080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe32080",
  null
  
)

export default component.exports